import { render, staticRenderFns } from "./SelfInvitation.vue?vue&type=template&id=f10fc350&scoped=true&"
import script from "./SelfInvitation.vue?vue&type=script&lang=js&"
export * from "./SelfInvitation.vue?vue&type=script&lang=js&"
import style0 from "./SelfInvitation.vue?vue&type=style&index=0&id=f10fc350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10fc350",
  null
  
)

export default component.exports